import { Link } from "react-router-dom";
import { ArrowLeft, Tag } from "lucide-react";
import { BUSINESS_INFO } from "../../lib/business-info";

const {
  companyName,
  ceoName,
  businessNumber,
  address,
  mailOrderNumber,
  phone,
  email,
  termsEffectiveDate,
} = BUSINESS_INFO;

// 공정거래위원회 전자상거래(인터넷사이버몰) 표준약관을 기준으로 작성했습니다.
// 조항을 수정할 때는 전자상거래 등에서의 소비자보호에 관한 법률과 충돌하지 않는지 확인하세요.
const ARTICLES = [
  {
    title: "제1조 (목적)",
    items: [
      `이 약관은 ${companyName}(이하 "회사")가 운영하는 온라인 쇼핑몰 TMTT.Link(이하 "몰")에서 제공하는 전자상거래 관련 서비스를 이용함에 있어 회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.`,
      "이 약관은 PC통신, 무선 등을 이용하는 전자상거래에 대해서도 그 성질에 반하지 않는 한 준용됩니다.",
    ],
  },
  {
    title: "제2조 (정의)",
    items: [
      `① "몰"이란 회사가 재화 또는 용역(이하 "재화등")을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 재화등을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 쇼핑몰을 운영하는 사업자의 의미로도 사용합니다.`,
      `② "이용자"란 "몰"에 접속하여 이 약관에 따라 "몰"이 제공하는 서비스를 받는 자를 말합니다.`,
      `③ "구매자"란 "몰"을 통해 재화등의 구매를 신청한 이용자를 말합니다.`,
    ],
  },
  {
    title: "제3조 (약관 등의 명시와 설명 및 개정)",
    items: [
      `① "몰"은 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소, 전화번호, 사업자등록번호, 통신판매업 신고번호, 개인정보보호책임자 등을 이용자가 쉽게 알 수 있도록 "몰"의 초기 서비스화면에 게시합니다.`,
      `② "몰"은 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 「전자문서 및 전자거래기본법」, 「전자금융거래법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「소비자기본법」 등 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.`,
      `③ "몰"이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 "몰"의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다.`,
      `④ 개정된 약관은 그 적용일자 이후에 체결되는 계약에만 적용되고, 그 이전에 이미 체결된 계약에 대해서는 개정 전의 약관조항이 그대로 적용됩니다.`,
      `⑤ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 관련 법령 또는 상관례에 따릅니다.`,
    ],
  },
  {
    title: "제4조 (서비스의 제공 및 변경)",
    items: [
      `① "몰"은 재화등에 대한 정보 제공 및 구매계약의 체결, 구매계약이 체결된 재화등의 배송, 기타 "몰"이 정하는 업무를 수행합니다.`,
      `② "몰"은 재화등의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화등의 내용을 변경할 수 있습니다. 이 경우에는 변경된 재화등의 내용 및 제공일자를 명시하여 즉시 공지합니다.`,
      `③ "몰"이 제공하기로 이용자와 계약을 체결한 재화등의 내용을 재화등의 품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게 통지 가능한 주소로 즉시 통지합니다.`,
    ],
  },
  {
    title: "제5조 (서비스의 중단)",
    items: [
      `① "몰"은 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.`,
      `② "몰"은 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, "몰"이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.`,
    ],
  },
  {
    title: "제6조 (구매신청 및 개인정보 제공 동의)",
    items: [
      `① 이용자는 "몰"에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, "몰"은 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.`,
      `1. 재화등의 검색 및 선택 2. 성명, 주소, 전화번호, 전자우편주소 등의 입력 3. 약관내용, 청약철회권이 제한되는 서비스, 배송료·설치비 등의 비용부담과 관련한 내용에 대한 확인 4. 이 약관에 동의하고 위 3.호의 사항을 확인하거나 거부하는 표시 5. 재화등의 구매신청 및 이에 관한 확인 또는 "몰"의 확인에 대한 동의 6. 결제방법의 선택`,
      `② "몰"은 재화등의 배송 등 계약의 이행을 위하여 필요한 최소한의 개인정보를 수집하며, 구매자의 개인정보를 제3자에게 제공할 필요가 있는 경우 실제 이용 시점에 사전에 구매자에게 제공되는 개인정보 항목, 제공받는 자, 이용 목적 및 보유·이용 기간 등을 명시하여 동의를 받습니다.`,
      `③ "몰"의 재화등의 결제 및 배송은 네이버 스마트스토어를 통해 이루어질 수 있으며, 이 경우 결제·주문 및 배송에 관하여는 네이버가 정한 절차와 정책이 함께 적용됩니다.`,
    ],
  },
  {
    title: "제7조 (계약의 성립)",
    items: [
      `① "몰"은 제6조와 같은 구매신청에 대하여 다음 각 호에 해당하면 승낙하지 않을 수 있습니다.`,
      `1. 신청 내용에 허위, 기재누락, 오기가 있는 경우 2. 미성년자가 법정대리인의 동의 없이 재화등을 구매하는 경우 3. 기타 구매신청에 승낙하는 것이 "몰" 기술상 현저히 지장이 있다고 판단하는 경우`,
      `② "몰"의 승낙이 제9조 제1항의 수신확인통지형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 봅니다.`,
      `③ "몰"의 승낙의 의사표시에는 이용자의 구매신청에 대한 확인 및 판매가능 여부, 구매신청의 정정·취소 등에 관한 정보 등을 포함하여야 합니다.`,
    ],
  },
  {
    title: "제8조 (지급방법)",
    items: [
      `"몰"에서 구매한 재화등에 대한 대금지급방법은 다음 각 호의 방법 중 가용한 방법으로 할 수 있습니다. 단, "몰"은 이용자의 지급방법에 대하여 재화등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수 없습니다.`,
      `1. 신용카드 결제 2. 계좌이체 및 무통장입금 3. 네이버페이 등 전자결제 서비스 4. 기타 "몰"이 추가 지정하는 결제수단`,
    ],
  },
  {
    title: "제9조 (수신확인통지 · 구매신청 변경 및 취소)",
    items: [
      `① "몰"은 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 합니다.`,
      `② 수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고, "몰"은 배송 전에 이용자의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다. 다만 이미 대금을 지불한 경우에는 제12조의 청약철회 등에 관한 규정에 따릅니다.`,
    ],
  },
  {
    title: "제10조 (재화등의 공급)",
    items: [
      `① "몰"은 이용자와 재화등의 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 청약을 한 날부터 7일 이내에 재화등을 배송할 수 있도록 주문제작, 포장 등 기타의 필요한 조치를 취합니다. 다만, "몰"이 이미 재화등의 대금의 전부 또는 일부를 받은 경우에는 대금의 전부 또는 일부를 받은 날부터 3영업일 이내에 조치를 취합니다.`,
      `② "몰"은 이용자가 구매한 재화에 대해 배송수단, 수단별 배송비용 부담자, 수단별 배송기간 등을 명시합니다. 만약 "몰"이 약정 배송기간을 초과한 경우에는 그로 인한 이용자의 손해를 배상하여야 합니다. 다만 "몰"이 고의·과실이 없음을 입증한 경우에는 그러하지 아니합니다.`,
    ],
  },
  {
    title: "제11조 (환급)",
    items: [
      `"몰"은 이용자가 구매신청한 재화등이 품절 등의 사유로 인도 또는 제공을 할 수 없을 때에는 지체 없이 그 사유를 이용자에게 통지하고, 사전에 재화등의 대금을 받은 경우에는 대금을 받은 날부터 3영업일 이내에 환급하거나 환급에 필요한 조치를 취합니다.`,
    ],
  },
  {
    title: "제12조 (청약철회 등)",
    items: [
      `① "몰"과 재화등의 구매에 관한 계약을 체결한 이용자는 「전자상거래 등에서의 소비자보호에 관한 법률」 제13조 제2항에 따른 계약내용에 관한 서면을 받은 날(그 서면을 받은 때보다 재화등의 공급이 늦게 이루어진 경우에는 재화등을 공급받거나 재화등의 공급이 시작된 날)부터 7일 이내에는 청약의 철회를 할 수 있습니다.`,
      `② 이용자는 재화등을 배송받은 경우 다음 각 호의 1에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.`,
      `1. 이용자에게 책임 있는 사유로 재화등이 멸실 또는 훼손된 경우 (다만, 재화등의 내용을 확인하기 위하여 포장 등을 훼손한 경우에는 청약철회를 할 수 있습니다) 2. 이용자의 사용 또는 일부 소비에 의하여 재화등의 가치가 현저히 감소한 경우 3. 시간의 경과에 의하여 재판매가 곤란할 정도로 재화등의 가치가 현저히 감소한 경우 4. 같은 성능을 지닌 재화등으로 복제가 가능한 경우 그 원본인 재화등의 포장을 훼손한 경우`,
      `③ 제2항 제2호 내지 제4호의 경우에 "몰"이 사전에 청약철회 등이 제한되는 사실을 소비자가 쉽게 알 수 있는 곳에 명기하거나 시용상품을 제공하는 등의 조치를 하지 않았다면 이용자의 청약철회 등이 제한되지 않습니다.`,
      `④ 이용자는 제1항 및 제2항의 규정에도 불구하고 재화등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된 때에는 당해 재화등을 공급받은 날부터 3월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을 할 수 있습니다.`,
    ],
  },
  {
    title: "제13조 (청약철회 등의 효과)",
    items: [
      `① "몰"은 이용자로부터 재화등을 반환받은 경우 3영업일 이내에 이미 지급받은 재화등의 대금을 환급합니다. 이 경우 "몰"이 이용자에게 재화등의 환급을 지연한 때에는 그 지연기간에 대하여 「전자상거래 등에서의 소비자보호에 관한 법률 시행령」에서 정하는 지연이자율을 곱하여 산정한 지연이자를 지급합니다.`,
      `② "몰"은 위 대금을 환급함에 있어서 이용자가 신용카드 또는 전자화폐 등의 결제수단으로 재화등의 대금을 지급한 때에는 지체 없이 당해 결제수단을 제공한 사업자로 하여금 재화등의 대금의 청구를 정지 또는 취소하도록 요청합니다.`,
      `③ 청약철회 등의 경우 공급받은 재화등의 반환에 필요한 비용은 이용자가 부담합니다. "몰"은 이용자에게 청약철회 등을 이유로 위약금 또는 손해배상을 청구하지 않습니다. 다만 재화등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행되어 청약철회 등을 하는 경우 재화등의 반환에 필요한 비용은 "몰"이 부담합니다.`,
      `④ 이용자가 재화등을 제공받을 때 발송비를 부담한 경우에 "몰"은 청약철회 시 그 비용을 누가 부담하는지를 이용자가 알기 쉽도록 명확하게 표시합니다.`,
    ],
  },
  {
    title: "제14조 (개인정보보호)",
    items: [
      `① "몰"은 이용자의 개인정보 수집 시 서비스제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다.`,
      `② "몰"은 재화등의 구매계약 이행에 필요한 정보를 미리 수집하지 않습니다. 다만, 관련 법령상 의무이행을 위하여 구매계약 이전에 본인확인이 필요한 경우로서 최소한의 특정 개인정보를 수집하는 경우에는 그러하지 아니합니다.`,
      `③ "몰"은 이용자의 개인정보를 수집·이용하는 때에는 당해 이용자에게 그 목적을 고지하고 동의를 받습니다.`,
      `④ "몰"은 수집된 개인정보를 목적 외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생한 경우 또는 제3자에게 제공하는 경우에는 이용·제공단계에서 당해 이용자에게 그 목적을 고지하고 동의를 받습니다.`,
      `⑤ 이용자는 언제든지 "몰"이 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 "몰"은 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다.`,
      `⑥ "몰"은 개인정보 보호를 위하여 이용자의 개인정보를 처리하는 자를 최소한으로 제한하며, 개인정보의 분실, 도난, 유출, 동의 없는 제3자 제공, 변조 등으로 인한 이용자의 손해에 대하여 모든 책임을 집니다.`,
    ],
  },
  {
    title: "제15조 (\"몰\"의 의무)",
    items: [
      `① "몰"은 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고 안정적으로 재화등을 제공하는데 최선을 다하여야 합니다.`,
      `② "몰"은 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함) 보호를 위한 보안 시스템을 갖추어야 합니다.`,
      `③ "몰"이 재화등에 대하여 「표시·광고의 공정화에 관한 법률」 제3조 소정의 부당한 표시·광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다.`,
      `④ "몰"은 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.`,
    ],
  },
  {
    title: "제16조 (이용자의 의무)",
    items: [
      `이용자는 다음 행위를 하여서는 안 됩니다.`,
      `1. 신청 또는 변경 시 허위내용의 등록 2. 타인의 정보도용 3. "몰"에 게시된 정보의 무단 변경 4. "몰"이 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시 5. "몰" 기타 제3자의 저작권 등 지적재산권에 대한 침해 6. "몰" 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위 7. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 "몰"에 공개 또는 게시하는 행위`,
    ],
  },
  {
    title: "제17조 (저작권의 귀속 및 이용제한)",
    items: [
      `① "몰"이 작성한 저작물에 대한 저작권 기타 지적재산권은 "몰"에 귀속합니다.`,
      `② 이용자는 "몰"을 이용함으로써 얻은 정보 중 "몰"에게 지적재산권이 귀속된 정보를 "몰"의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.`,
    ],
  },
  {
    title: "제18조 (분쟁해결)",
    items: [
      `① "몰"은 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.`,
      `② "몰"은 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.`,
      `③ "몰"과 이용자 간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.`,
      `④ 소비자 분쟁이 발생한 경우 공정거래위원회 고시 「소비자분쟁해결기준」에 따라 처리합니다.`,
    ],
  },
  {
    title: "제19조 (재판권 및 준거법)",
    items: [
      `① "몰"과 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 「민사소송법」상의 관할법원에 제기합니다.`,
      `② "몰"과 이용자 간에 제기된 전자상거래 소송에는 대한민국 법을 적용합니다.`,
    ],
  },
];

const COMPANY_ROWS = [
  ["상호명", companyName],
  ["대표자명", ceoName],
  ["사업자등록번호", businessNumber],
  ["주소", address],
  ["통신판매업신고번호", mailOrderNumber],
  ["전화번호", phone],
  ["전자우편주소", email],
];

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50">
      <div className="fixed inset-0 -z-10 bg-[radial-gradient(circle_at_top_left,rgba(14,165,233,0.16),transparent_32%),linear-gradient(180deg,#09090b_0%,#020617_100%)]" />

      <header className="sticky top-0 z-40 border-b border-white/10 bg-zinc-950/75 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-3xl items-center gap-3 px-4 sm:px-6">
          <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-white text-zinc-950">
            <Tag className="h-5 w-5" />
          </div>
          <span className="text-lg font-semibold tracking-tight">TMTT.Link</span>
          <span className="ml-1 rounded-full border border-white/10 bg-white/5 px-2 py-0.5 text-xs font-medium text-zinc-300">
            이용약관
          </span>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:py-14">
        <Link
          to="/"
          className="mb-8 inline-flex items-center gap-2 text-sm font-medium text-zinc-400 transition-colors hover:text-white"
        >
          <ArrowLeft className="h-4 w-4" />
          홈으로
        </Link>

        <h1 className="text-3xl font-semibold tracking-tight md:text-4xl">이용약관</h1>
        <p className="mt-3 text-sm text-zinc-400">
          시행일: {termsEffectiveDate}
        </p>
        <p className="mt-2 text-xs leading-6 text-zinc-500">
          This page contains the Korean-language terms of service governing purchases made through TMTT.Link,
          in accordance with the Republic of Korea&apos;s Act on Consumer Protection in Electronic Commerce.
        </p>

        <section className="mt-8 rounded-3xl border border-white/10 bg-white/[0.04] p-5 md:p-6">
          <h2 className="text-sm font-semibold text-zinc-100">사업자 정보</h2>
          <dl className="mt-4 space-y-2.5">
            {COMPANY_ROWS.map(([label, value]) => (
              <div key={label} className="flex flex-col gap-0.5 sm:flex-row sm:gap-3">
                <dt className="shrink-0 text-xs font-medium text-zinc-400 sm:w-36">{label}</dt>
                <dd className="text-sm text-zinc-200">{value}</dd>
              </div>
            ))}
          </dl>
        </section>

        <div className="mt-10 space-y-9">
          {ARTICLES.map((article) => (
            <section key={article.title}>
              <h2 className="text-base font-semibold text-zinc-100">{article.title}</h2>
              <div className="mt-3 space-y-3">
                {article.items.map((item, index) => (
                  <p key={index} className="text-sm leading-7 text-zinc-400">
                    {item}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-12 rounded-3xl border border-white/10 bg-white/[0.04] p-5 md:p-6">
          <h2 className="text-sm font-semibold text-zinc-100">부칙</h2>
          <p className="mt-3 text-sm leading-7 text-zinc-400">
            이 약관은 {termsEffectiveDate}부터 시행합니다.
          </p>
        </div>
      </main>
    </div>
  );
}
